module.exports = __webpack_public_path__ + "static/img/ichat_2@2x.e6e0482.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/ichat_2@2x.jpg
// module id = 487
// module chunks = 0